<div class="row mt-5" *ngIf="data!==null">
  <div class="col-lg-12">
    <div class="card shadow-lg wow bounceInDown" data-wow-duration="2s" [style.opacity]="'0.9'">
      <div class="card-header">
        <h1 class="card-title">
          <code class="text-purple">{{query}}</code>
        </h1>

        <p class="">
          <span class="badge badge-dark mr-1" *ngFor="let type of data?.observable?.type">{{type.replaceAll('_', ' ').toUpperCase()}}</span>
          <span *ngIf="data?.observable?.geo">
            <br />
            <i class="flag flag-{{data?.observable?.geo?.country_iso_code?.toLowerCase()}}"></i>&nbsp;<span
              *ngIf="data?.observable?.geo?.city_name">{{data?.observable?.geo?.city_name}},
            </span>{{data?.observable?.geo?.country_name}}
          </span>
          <span *ngIf="data?.observable?.as">
            <br />
            <i class="fas fa-globe"></i>&nbsp;ASN{{data?.observable?.as?.asn}}&nbsp;<span
              *ngIf="data?.observable?.as?.organization_name">{{data?.observable?.as?.organization_name}}</span>
          </span>
          <span *ngIf="data?.observable?.last_seen">
            <br />
            <i class="fas fa-calendar-day"></i>&nbsp;First seen:&nbsp;<span title="first seen">{{data?.observable?.first_seen | date: 'medium'}}</span>
            <br />
            <i class="fas fa-calendar-day"></i>&nbsp;Last seen:&nbsp;<span title="last seen">{{data?.observable?.last_seen | date: 'medium'}}</span>
          </span>
          <span *ngIf="data?.related?.length">
            <br />
            <i class="fas fa-link"></i>&nbsp;
            <span *ngFor="let related of data?.related"><a [routerLink]="['/search']" [queryParams]="{query: related.value}">{{shorten(related.value)}}</a>&nbsp;</span>
          </span>
        </p>
        <div *ngIf="data?.observable?.whois">
          <a href="javascript://" data-toggle="collapse" data-target="#whois-collapse">View WHOIS data</a>
          <div class="collapse" id="whois-collapse">
            
              <table class="table card-body table-bordered table-condensed table-striped">
                <tbody>
                  <tr *ngFor="let whois of data.observable.whois | keyvalue">
                    <th>{{whois.key}}</th>
                    <td>{{whois.value}}</td>
                  </tr>
                </tbody>
              </table>
            
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="col-lg-12 mt-2" *ngIf="data === false || !data.observable">
    <div class="alert alert-danger" role="alert">
      <h4 class="alert-heading">Not Found</h4>
      <p>Sorry, we haven't found "{{query}}" in our latest analysis records. It could means: </p>
      <ul>
        <li>We haven't collect this artifact yet</li>
        <li>Analysis results are not ready for publication</li>
      </ul>
      <hr>
      <p class="mb-0">If you think this is an error, feel free to contact us.</p>
    </div>

  </div>

  <div class="col-lg-12 mt-2" *ngIf="data?.analysis?.length > 0">
    <div class="card bg-white shadow-lg wow bounceInDown" data-wow-duration="2s">
      <div class="card-body">
        <h2 *ngIf="data?.threatscore?.smart_level">
          Threat score of
          <b [ngClass]="{'text-success': data.threatscore.smart_level.toUpperCase() === 'SAFE', 'text-warning': data.threatscore.smart_level.toUpperCase() === 'SUSPICIOUS', 'text-danger': data.threatscore.smart_level.toUpperCase() === 'MALICIOUS'}">
            {{ (data?.threatscore?.smart_score  * 100 | number:'1.0-0')}}%&nbsp;<small><em>({{data?.threatscore?.smart_level?.toUpperCase()}})</em></small>
          </b>
        </h2>
        <span class="text-muted" *ngIf="data?.threatscore?.level">
          Original score of
          <b [ngClass]="{'text-success': data.threatscore.level.toUpperCase() === 'SAFE', 'text-warning': data.threatscore.level.toUpperCase() === 'SUSPICIOUS', 'text-danger': data.threatscore.level.toUpperCase() === 'MALICIOUS'}">
            {{ (data?.threatscore?.value  * 100 | number:'1.0-0')}}%&nbsp;
          </b>
        </span>
        <p>
          Categories: <span class="badge badge-dark mr-1" *ngFor="let category of data?.threatscore?.categories">{{category.replaceAll('_', ' ').toUpperCase()}}</span>
 <br/>Indicators: 
          <span class="badge mr-1" [ngClass]="{'badge-danger': data?.threatscore?.indicators?.blocklist, 'badge-light': !data?.threatscore?.indicators?.blocklist}">
            <span *ngIf="data?.threatscore?.indicators?.blocklist">
              <i class="fas fa-check"></i>
              &nbsp;Blocklist
            </span>
            <del *ngIf="!data?.threatscore?.indicators?.blocklist">
              <i class="fas fa-times"></i>
              &nbsp;Blocklist
            </del>
          </span>
          <span class="badge mr-1" [ngClass]="{'badge-danger': data?.threatscore?.indicators?.attack, 'badge-light': !data?.threatscore?.indicators?.attack}">
            <span *ngIf="data?.threatscore?.indicators?.attack">
              <i class="fas fa-check"></i>
              &nbsp;Attack
            </span>
            <del *ngIf="!data?.threatscore?.indicators?.attack">
              <i class="fas fa-times"></i>
              &nbsp;Attack
            </del>
          </span>
          <span class="badge mr-1" [ngClass]="{'badge-danger': data?.threatscore?.indicators?.scan, 'badge-light': !data?.threatscore?.indicators?.scan}">
            <span *ngIf="data?.threatscore?.indicators?.scan">
              <i class="fas fa-check"></i>
              &nbsp;Scan
            </span>
            <del *ngIf="!data?.threatscore?.indicators?.scan">
              <i class="fas fa-times"></i>
              &nbsp;Scan
            </del>
          </span>
          <span class="badge mr-1" [ngClass]="{'badge-danger': data?.threatscore?.indicators?.compromission, 'badge-light': !data?.threatscore?.indicators?.compromission}">
            <span *ngIf="data?.threatscore?.indicators?.compromission">
              <i class="fas fa-check"></i>
              &nbsp;Compromission
            </span>
            <del *ngIf="!data?.threatscore?.indicators?.compromission">
              <i class="fas fa-times"></i>
              &nbsp;Compromission
            </del>
          </span>
        </p>
       
      </div>
    </div>
  </div>

  <div class="col-lg-4 mt-2" *ngIf="data?.sources?.length > 0">
    <div class="card bg-white shadow-lg wow bounceInDown" data-wow-duration="2s">
      <div class="card-body">
        <p class="text-secondary">
          <i class="fas fa-list-ol"></i>&nbsp;<b>{{data?.sources?.length}}</b>&nbsp;sources
        </p>
        <apx-chart
        [series]="sourcesChart.series"
        [chart]="sourcesChart.chart"
        [labels]="sourcesChart.labels"
        [legend]="sourcesChart.legend"
        [plotOptions]="sourcesChart.plotOptions"></apx-chart>
      </div>
    </div>
  </div>

  <div class="col-lg-8 mt-2" *ngIf="data?.analysis?.length > 0">
    <div class="card bg-white shadow-lg wow bounceInDown" data-wow-duration="2s">
      <div class="card-body">
        <p class="text-secondary">
          <i class="fas fa-list-ol"></i>&nbsp;<b>{{number_of_scores}}</b>&nbsp;scores
        </p>
        <apx-chart
        [series]="analysisChart.series"
        [chart]="analysisChart.chart"
        [xaxis]="analysisChart.xaxis"
        [yaxis]="analysisChart.yaxis"
        [stroke]="analysisChart.stroke"
        [legend]="analysisChart.legend"
        [tooltip]="analysisChart.tooltip"
        [dataLabels]="analysisChart.dataLabels"
        [fill]="analysisChart.fill"></apx-chart>
      </div>
    </div>
  </div>

  <div class="col-lg-12 mt-2" *ngIf="data?.analysis?.length > 0">
    <div class="card bg-white shadow-lg wow bounceInDown" data-wow-duration="2s">
      <div class="card-body px-0">
        <p class="text-secondary px-4">
          <i class="fas fa-list-ol"></i>&nbsp;<b>{{data?.analysis?.length}}</b>&nbsp;analysis
        </p>
        
        <table class="table table-white">
          <thead>
            <tr>
              <th><i class="fas fa-info-circle"></i>&nbsp;ID</th>
              <th><i class="fas fa-calendar-day"></i>&nbsp;Date</th>
              <th><i class="fas fa-exclamation"></i>&nbsp;Threat level</th>
              <th><i class="fas fa-info-circle"></i>&nbsp;Taxonomy</th>
            </tr>
          </thead>
          <tbody *ngFor="let item of data?.analysis_summary | keyvalue">
            <tr *ngFor="let a of item.value; let i = index;">
              <td *ngIf="i===0" [attr.rowspan]="item?.value?.length"  class="text-muted">Analysis engine <code>{{item.key}}</code></td>
              <td>{{a?.date | date: 'medium'}}</td>
              <td>
                <b *ngIf="a?.level" [ngClass]="{'text-success': a.level === 'SAFE', 'text-warning': a.level === 'SUSPICIOUS', 'text-danger': a.level === 'MALICIOUS'}">
                  <span *ngIf="a.level === 'SAFE'">
                    <i class="fas fa-shield-alt"></i>
                  </span>
  
                  <span *ngIf="a.level === 'SUSPICIOUS'">
                    <i class="fas fa-exclamation-triangle"></i>
                  </span>
  
                  <span *ngIf="a.level === 'MALICIOUS'">
                    <i class="fas fa-biohazard"></i>
                  </span>
                  {{a?.level?.toUpperCase()}}
                </b>
                <b *ngIf="!a.level">-</b>
              </td>
              <td>
                <span *ngIf="a?.parameter">
                  {{a?.parameter}}
                  &nbsp;<small><i class="fas fa-arrow-right"></i></small>&nbsp;
                  {{a?.value}}
                </span>
                <span *ngIf="!a?.parameter">
                  <i class="fas fa-eye-slash"></i>&nbsp;<em>hidden</em>
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<div class="row" *ngIf="data === null">
  <div class="col-lg-12 text-center mt-5 bg-white shadow-lg" [style.border-radius]="'90px'" [style.opacity]="'0.9'">
    <img width="100" src="assets/img/loading.gif" alt="Loading ..." title="Loading ...">
  </div>
</div>